export default function parserContextual(targetId, contextualData) {
  const dataParsed = [];
  let i = 0;
  if (Array.isArray(contextualData.playlist)) {
    contextualData.playlist.forEach((item) => {
      const videoData = item;
      videoData.index = i;
      i += 1;
      const [source] = videoData.source;
      videoData.typeFactory = 'native';
      videoData.url = source;
      videoData.idVideoElement = `${targetId}_${videoData.id}_video`;
      videoData.typeFactory = 'native';
      dataParsed.push(videoData);
    });
  }
  return dataParsed;
}
